<template>
  <div class="content">
    <div class="header">
      <div
        v-for="(item,index) in labledata"
        :key="index"
        :class="{heightlight : lableindex==index}"
        @click="lableArea(index,item)"
      >
        {{item}}
        <div v-if="lableindex==index" class="xian"></div>
      </div>
    </div>
    <div class="metter">
      <el-table ref="JLTable" :key="tableKey" :data="list" border style="width:100%">
        <el-table-column min-height="140px" :label="'名称'" align="left" prop="title" show-overflow-tooltip>
          <template slot-scope="scope">
            <span class="title-text-up">{{scope.row.title}}</span>
          </template>
        </el-table-column>

        <el-table-column
          width="80px"
          min-height="140px"
          :label="'状态'"
          align="center"
          prop="stateName"
        ></el-table-column>
        <el-table-column
          min-height="140px"
          width="140px"
          :label="'开始时间'"
          align="center"
          prop="begintime"
        ></el-table-column>
        <el-table-column
          min-height="140px"
          width="140px"
          :label="'结束时间'"
          align="center"
          prop="endtime"
        ></el-table-column>
        <el-table-column width="80px" min-height="140px" :label="'成绩'" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.isSubmit && scope.row.isOpen">{{scope.row.sumScore}} 分</span>
            <span v-else-if="scope.row.isSubmit && scope.row.isOpen==false">未公布</span>
            <span v-else>未参加</span>
          </template>
        </el-table-column>

        <el-table-column
          align="center"
          :label="'操作'"
          width="150"
          class-name="small-padding fixed-width"
        >
          <template slot-scope="scope">
            <!-- <el-button type="primary" plain size="mini" @click="handleUpdate(scope.row)">编辑</el-button> -->

            <el-button v-if="scope.row.examStatus !== 2" type="info" size="mini" plain disabled>考试</el-button>

            <el-button
              v-else-if="scope.row.examStatus == 2 && scope.row.isSubmit "
              type="info"
              plain
              @click="goExam(scope.row)"
              disabled
              size="mini"
            >考试</el-button>

            <el-button v-else type="success" size="mini" @click="goExam(scope.row)">考试</el-button>

            <el-button
              type="primary"
              plain
              @click="selectExam(scope.row)"
              size="mini"
              :disabled="!scope.row.isSubmit || !scope.row.isopen2"
            >结果</el-button>
            <!-- <el-button type="info" plain size="mini">成绩排行</el-button> -->
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="pagination">
      <el-pagination
        background
        prev-text="上一页"
        next-text="下一页"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage2"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="10"
        layout="total,sizes, prev, pager, next"
        :total="total"
        v-if="total>0"
      ></el-pagination>
    </div>
    <el-dialog width="55%" :visible.sync="enterDialogVisible" center @close="closeDialog">
      <EnterExamDialog v-if="enterDialogVisible" :titleExam="titleExam" :examInfoObj="examInfo"></EnterExamDialog>
    </el-dialog>
    <el-dialog
      width="80%"
      :visible.sync="prviewPaperVisible"
      :show-close="false"
      @close="closeJGDialog"
      v-if="prviewPaperVisible"
    >
      <PrviewPaper
        v-if="prviewPaperVisible"
        @closeJGDialog="closeJGDialog"
        :titleExam="titleExam"
        :examID="examID"
        :processId="processId"
      ></PrviewPaper>
    </el-dialog>
  </div>
</template>

<script>
import * as Personcenter from '@/api/personcenter/index';
import EnterExamDialog from './component/enterExamDialog';
import PrviewPaper from './component/prviewPaper';

export default {
  components: {
    EnterExamDialog,
    PrviewPaper,
  },
  data() {
    return {
      tableKey: 0,
      labledata: ['全部', '未开始', '进行中', '已结束'],
      currentPage2: 1,
      lableindex: 0,
      listQuery: {
        page: 1,
        limit: 10,
        userId: this.$store.state.User.ids,
        type: 0,
      },
      total: 0,
      list: [],
      enterDialogVisible: false,
      prviewPaperVisible: false,
      titleExam: '',
      examInfo: null,
      examID: 0,
      processId:0
    };
  },
  created() {
    this.getList();
  },
  methods: {
    closeJGDialog() {
      this.prviewPaperVisible = false;
    },
    //查看结果
    selectExam(item) {
      this.titleExam = item.title;
      this.examID = item.examId;
      this.processId = item.id;
      this.prviewPaperVisible = true;
    },
    closeDialog() {
      this.enterDialogVisible = false;
    },
    //点击立即考试
    goExam(item) {
      this.titleExam = item.title;
      this.examInfo = item;
      localStorage.setItem('Id', item.examId);
      // localStorage.setItem('paperId', item.paperid);
      localStorage.setItem('paperId', item.examId);
      this.enterDialogVisible = true;
    },
    getList() {
      Personcenter.getMyExam(this.listQuery).then((res) => {
        this.list = res.data;
        this.total = res.count;
      });
    },
    lableArea(index, item) {
      this.listQuery.type = index;
      this.listQuery.page = 1;
      this.lableindex = index;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
  },
};
</script>
<style scoped>
.content {
  /* width: 900px; */
  width: 100%;
  /* height: 1000px; */
  padding-bottom: 20px;
}
hr {
  margin: 1px;
  border-top: 1px solid #e2e3e6;
}
.heightlight {
  color: #409eff !important;
}
.header {
  /* width: 850px; */
  height: 35px;
  border-bottom: solid 1px #ccc;
  padding-top: 10px;
  display: flex;
}
.header > div {
  width: 100px;
  text-align: center;
  line-height: 35px;
  font-size: 16px;
  cursor: pointer;
}
.header > div:hover {
  color: #409eff;
}
.xian {
  width: 90px;
  border: solid 1px #409eff;
  margin-left: 8px;
}
.metter {
  /* width: 850px; */
}
.nav {
  margin-top: 16px;
  border-radius: 10px;
  border-style: solid;
  border-color: rgba(255, 255, 255, 1);
  border: 1px solid #f2f2f2;
  padding-top: 16px;
  margin-left: 20px;
}

.navfirst {
  font-weight: 700;
  font-size: 16px;
  border-bottom: solid 1px #f2f2f2;
  padding: 0 0 10px 10px;
}
hr {
  margin-top: 10px;
}

.navsecond {
  line-height: 30px;
  color: #7f7f7f;
  font-size: 15px;
  border-bottom: solid 1px #f2f2f2;
  padding: 5px 10px 10px 10px;
}
.navthirt {
  padding: 10px;
  text-align: right;
}
.pagination {
  margin-top: 20px;
  text-align: center;
}
.navsecondheadty {
  display: flex;
}
.navsecondright {
  flex: 1;
}
.title-text-up:hover {
  color: rgb(0, 162, 255);
  text-decoration: underline;
  cursor: pointer;
}
</style>